import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UpsSasToken } from 'src/app/models/utils.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

@Injectable()
export class RestUtilsService extends BaseApiService {

  constructor(httpClient: HttpClient,
    translate: TranslateFirebaseService,
    private authService: AuthService) {
    super(httpClient, translate);
  }

  getSasToken(queryString : string): Observable<UpsSasToken> {
    return this.httpClient.get<UpsSasToken>(super.getUpsApiHost() + 'Sas' + queryString, { headers: this.authService.upsHttpHeaders });
  }

  getVersion(): Observable<Blob> {
    return this.httpClient.get(super.getUpsApiHost() + 'version', { headers: this.authService.upsHttpHeaders, responseType: 'blob' });
  }
}
